import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';

@Component({
  selector: 'app-sport-list',
  templateUrl: './sport-list.component.html',
  styleUrls: ['./sport-list.component.css']
})
export class SportListComponent extends BaseClass<any> implements OnInit {
  public data: any;
  @Input() list!: any;
  @Input() eventId!: any;
  @Input() eventName!: any;
  @Input() oddsData!: any;
  @ViewChild('staticTabs', { static: false }) staticTabs?: TabsetComponent;


  public odds: any;
  public id = '';
  public eId = '';
  public eName = '';
  public marketsReq: any[] = [];

  constructor(
    public service: WebserviceService,
    public actRoute: ActivatedRoute,
    public _shared: SharedService,
    public router: Router
  ) { super(); }

  ngOnInit(): void {
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  listByTypeId(items: any, id: any) {
    const grouped = this.groupBy(items, (dat: any) => dat.event_type_id);
    return grouped.get(id) ? grouped.get(id) : [];
  }

  listByinPlay(items: any) {
    return items.filter((s: any) => !this.events.races.includes(s?.event_type_id));
    // const grouped = this.groupBy(items, (dat: any) => dat.in_play);
    // return grouped.get(1) ? grouped.get(1) : [];
  }

  reArrangeRaceData(items: any, id: any) {
    items = this.listByTypeId(items, id);

    let rc = items.map((a: any) => (a.event_name));
    const uniqueSet1 = new Set(rc);
    rc = [...uniqueSet1];
    rc = rc.map((a: any) => ({ race: '', event_name: a, data: [] }));
    const grouped = this.groupBy(items, (dat: any) => dat.event_name);

    rc.forEach((element: any) => {
      let dt = grouped.get(element.event_name) ? grouped.get(element.event_name) : [];
      
      // let rcd = dt.map((a: any) => (a.event_id));
      // const uniqueSet1 = new Set(rcd);
      // rcd = [...uniqueSet1];
      // rcd = rcd.map((a: any) => ({ event_id: a, event_name: '', data: [] }));
      // const groupedByEvent = this.groupBy(dt, (dat: any) => dat.event_id);

      // rcd.forEach((eEle: any) => {
      //   eEle.data = [...eEle.data, ...groupedByEvent.get(eEle.event_id) ? groupedByEvent.get(eEle.event_id) : []]
      //   eEle.event_name = eEle.data[0]?.event_name;
      // });

      // element.data = rcd
      element.data = dt
    });

    return rc;
  }

  ngOnChanges() {
    if (this.list) {

      if (this.eventId == 'in_play') {
        this.data = (this.events.races.includes(this.eventId)) ? this.reArrangeRaceData(this.list, this.eventId) : this.listByinPlay(this.list);
      } else {
        this.data = (this.events.races.includes(this.eventId)) ? this.reArrangeRaceData(this.list, this.eventId) : this.listByTypeId(this.list, this.eventId);
      }

      this.odds = this.oddsData;
      this.eId = this.eventId;
      this.eName = this.eventName;
    }

    this.selectTab(0);
  }

  redirectSportDetail(e: any) {
    this.router.navigate(['/sports/detail', e.event_id])
    // if (this.getToken()) {
    //   this.router.navigate(['/sports/detail', e.event_id])
    // } else {
    //   this._shared.emitLoginModal('login');
    // }
  }

  redirectRaceDetail(race: any) {
    this.router.navigate(['/sports/detail', race.event_id, Number(race.market_id)])
    // if (this.getToken()) {
    //   this.router.navigate(['/sports/detail', race.event_id, Number(race.market_id)])
    // } else {
    //   this._shared.emitLoginModal('login');
    // }
  }

  selectTab(tabId: number) {
    if (this.staticTabs?.tabs[tabId]) {
      this.staticTabs.tabs[tabId].active = true;
    }
  }
  
}
